import{createContext}from'react';export default/*#__PURE__*/createContext({smallMinBreakpoint:'xs',largeMinBreakpoint:'lg'});
//# sourceMappingURL=ResponsiveContext.js.map